import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataActivity } from "../../features/Activity/Activity";
import { Link } from "react-router-dom";
import { convertDate } from "../../features/ConvertDate";
import { useTranslation } from "react-i18next";
import NoResultsPage from "../NoResultsPage";
import { ReadMore } from "../../Buttons/Buttons";

function OtherActivity({ expectId }) {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(fetchDataActivity({ perPage: 6, expectId }));
  }, [dispatch, expectId]);

  const { activities } = useSelector((state) => state.activity);
  const { t } = useTranslation();
  const isRTL = ['ar', 'ckb'].includes(i18n.language || localStorage.getItem("lang"));

  return (
    <div className={`px-4 py-12 md:px-6 lg:px-8 max-w-5xl border border-gray-200   mx-auto ${isRTL ? 'rtl' : 'ltr'}`}>
      {/* Section Header */}
      
        {/* <div className="hidden md:block flex-grow h-px bg-gradient-to-r from-blue-100 to-transparent mr-4"></div> */}
        <h1 className={`text-3xl md:text-4xl ${isRTL ? 'text-right' : 'text-left'} font-bold text-gray-800  px-4 my-3  py-2 rounded-lg`}>
          {t("otherActivity")}
        </h1>
        {/* <div className="hidden md:block flex-grow h-px bg-gradient-to-r from-transparent to-blue-100 ml-4"></div> */}
      

      {/* Activities Grid */}
      <div className="space-y-6">
        {activities?.length > 0 ? activities.map((activity) => (
          <div 
            key={activity.id} 
            className="bg-white flex flex-col border border-gray-400/70 md:flex-row gap-0 rounded-2xl  overflow-hidden transition-all duration-300 "
          >
            {/* Image Section */}
            <Link 
              to={`/activity/${activity.id}`} 
              className="block md:w-2/5 h-full md:h-52 overflow-hidden relative group"
            >
              <img
                src={process.env.REACT_APP_IMG_URL + activity.image}
                alt={activity.title}
                className="w-full  md:h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </Link>
            
            {/* Content Section */}
            <div className="p-5 md:w-3/5 flex flex-col">
              <Link to={`/activity/${activity.id}`}>
                <h2 className="text-xl font-semibold text-gray-800 mb-3 hover:text-teal-600 transition-colors duration-300">
                  {activity.title}
                </h2>
              </Link>
              
              <div 
                className="text-gray-600  prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ 
                  __html: activity.description.length > 120 
                    ? activity.description.slice(0, 120) + "..." 
                    : activity.description 
                }}
              ></div>
              
              <div className="mt-auto">
                <ReadMore 
                  text={activity.description} 
                  className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-300 inline-flex items-center" 
                />
              </div>
            </div>
          </div>
        )) : (
          <NoResultsPage />
        )}
      </div>
    </div>
  );
}

export default OtherActivity;